import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { languages } from "../constants/languages";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const styles = (theme) => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    width: "95%",
    maxWidth: 400,
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: 90,
  }),
  textField: {
    margin: theme.spacing(1),
    width: 200,
  },
  button: {
    margin: theme.spacing(1),
  },
  headline: {
    margin: theme.spacing(1),
  },
  link: {
    display: "block",
    margin: theme.spacing(1),
  },
});

const Signup = (props) => {
  const { classes } = props;
  return (
    <div>
      <Paper className={classes.root} elevation={4}>
        <Typography variant="h5" component="h3" className={classes.headline}>
          {languages.login.signup2}
        </Typography>
        <TextField
          name="firstName"
          label={languages.login.firstName}
          value={props.firstName}
          onChange={props.handleChange}
          className={classes.textField}
        />
        <TextField
          type="email"
          name="email"
          label={languages.login.email}
          value={props.email}
          onChange={props.handleChange}
          className={classes.textField}
        />
        <TextField
          type="password"
          name="password"
          label={languages.login.password}
          value={props.password}
          onChange={props.handleChange}
          className={classes.textField}
        />
        <TextField
          type="password"
          name="passwordConfirm"
          label={languages.login.passwordConfirm}
          value={props.passwordConfirm}
          onChange={props.handleChange}
          className={classes.textField}
        />
        <div className={classes.headline}>
          {languages.login.acceptGeneralTermsMessage + " "}
          <a
            href={languages.misc.generalTermsURL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {languages.login.generalTerms.toLowerCase()}
          </a>
          {"."}
        </div>
        <div className={classes.textField} style={{ color: "red" }}>
          {props.errorMessage}
        </div>
        <Button
          variant="contained"
          color="primary"
          className={classes.button}
          onClick={props.handleSignup}
        >
          {languages.login.signup2}
        </Button>
        <Link to="/" className={classes.link}>
          {languages.login.back}
        </Link>
      </Paper>
    </div>
  );
};

Signup.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Signup);
